module.exports = __webpack_public_path__ + "img/figure-8.df670130.png";